import type { ReactNode } from 'react';
import { useState } from 'react';
import {
  type PageSidebarSlot,
  PageLayoutContext,
  PageLayoutSlotContext,
} from './context';

type Props = {
  children: ReactNode;
};
export default function PageLayoutProvider({ children }: Props) {
  const [pageHeaderSlot, setPageHeaderSlot] = useState<ReactNode>(null);
  const [pageSidebarSlot, setPageSidebarSlot] = useState<PageSidebarSlot | null>(
    null,
  );

  return (
    <PageLayoutContext value={{ setPageHeaderSlot, setPageSidebarSlot }}>
      <PageLayoutSlotContext value={{ pageHeaderSlot, pageSidebarSlot }}>
        {children}
      </PageLayoutSlotContext>
    </PageLayoutContext>
  );
}
